import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SystemNotificationComponent } from './system-notification.component';
import { SpinnerModule } from '../spinner/spinner.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [SystemNotificationComponent],
  exports: [SystemNotificationComponent],
  entryComponents: [SystemNotificationComponent],
  imports: [CommonModule, AngularSvgIconModule, SpinnerModule, PipesModule]
})
export class SystemNotificationModule {}

export { SystemNotificationComponent };

export * from './system-notification-type.enum';
